<div class="flex items-center justify-center h-full">
  <div
    class="bg-white px-4 py-8 sm:p-8 shadow-md rounded-lg w-full max-w-[420px]"
  >
    <div class="logo-bar">
      <img src="assets/maxbrain-logo.svg" alt="MaxBrain" />
    </div>

    <h2
      class="font-bold text-[28px] leading-8 tracking-normal text-center mb-6 text-[var(--color-darkgraytextcolor)]"
    >
      Choose organization
    </h2>

    @if (tenantService.tenants().length > 0) {
    <div class="relative w-full max-w-md mt-2">
      <input
        type="text"
        [formControl]="searchControl"
        placeholder="Search"
        class="w-full p-2 pl-10 border border-[#E0E0E0] rounded h-[52px] focus:ring-0 focus:outline-none"
      />

      <!-- Search Icon -->
      <ng-icon
        name="heroMagnifyingGlassSolid"
        class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
        size="20px"
      />
    </div>

    @if (tenantService.filteredTenants().length > 0) {
    <div class="mt-4 max-h-[280px] overflow-y-auto pr-2">
      @for (tenant of tenantService.filteredTenants(); track tenant.tenant_id;
      let i = $index) {
      <div
        class="tenant-item w-full rounded-md p-4 gap-2 mb-2 cursor-pointer bg-gray-100 hover:bg-gray-200"
        [class.bg-gray-200]="isSelected(i)"
        (click)="navigateToTenant(tenant)"
      >
        <div class="flex items-center">
          <div class="bg-white flex items-center mr-2 w-10 h-10 p-1">
            <img
              src="{{ tenant.logo_url || 'assets/maxbrain-logo.svg' }}"
              alt="Tenant Logo"
              class="object-contain"
              loading="lazy"
            />
          </div>
          <div class="flex items-center justify-between w-full">
            <div class="flex flex-col ml-2">
              <h2
                class="font-semibold text-sm leading-none tracking-normal mb-1 text-[var(--color-darkgraytextcolor)]"
              >
                {{ tenant.name }}
              </h2>
              <span class="text-sm leading-none tracking-normal text-gray-500">
                {{ tenant.subdomain }}
              </span>
            </div>

            <ng-icon name="heroChevronRightSolid" class="w-8 h-8" size="18px" />
          </div>
        </div>
      </div>
      }
    </div>
    } @else {
    <!-- No Search Results -->
    <div
      class="flex flex-col items-center justify-center h-[280px] bg-gray-50 mt-4"
    >
      <img
        src="assets/icons/ic_no_search_results.svg"
        alt="No Matches"
        width="151"
        height="136"
      />
      <div class="mt-4 text-center text-[var(--color-darkgraytextcolor)]">
        <p>No matches found.</p>
        <p>Try a different search term.</p>
      </div>
    </div>
    } } @else {
    <div
      class="flex flex-col items-center justify-center h-[280px] bg-gray-50 mt-4"
    >
      <img
        src="assets/icons/ic_no_tenants.svg"
        alt="No Tenants"
        width="151"
        height="136"
      />
      <div class="mt-4 text-center text-[var(--color-darkgraytextcolor)]">
        <p>No organization found.</p>
        <p>Ask your admin to add you.</p>
      </div>
    </div>
    }

    <div class="text-center text-sm leading-5 mt-8 mb-4 flex flex-col">
      <!-- <span class="text-gray-500">You're logged in as: </span> -->
      <span
        class="cursor-pointer text-[var(--color-primary-800)]"
        (click)="logout()"
        >Use a different email</span
      >
    </div>
  </div>
</div>
